import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { FetchEfectorFacturacion } from "../../../../../actions/reclamos/reclamosActions";
import { TIPO_EFECTORES } from "../../../../../utils/constants";

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

export const EfectorMenu = ({ efector,   solicitud }) => {

    const { dataEfector } = useSelector((state) => state.reclamos);
    const dispatch = useDispatch();
  
    useEffect(() => {
      dispatch(FetchEfectorFacturacion(efector));
    }, [dispatch]);

  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Información efector
      </Typography>
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Razon Social: 
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {dataEfector?.razonSocial}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Id efector:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {dataEfector?.idEfectorFacturacion}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Correo electrónico:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {solicitud?.email}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Cuit:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {dataEfector?.cuit}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Teléfono:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {solicitud?.telefono}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Celular:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {solicitud?.celular}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Fecha de alta:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {new Date(dataEfector?.fechaInicioVigencia).toLocaleString(
                "es",
                optionsfecha
              )}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              tipo:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                 {dataEfector?.idTipoEfector === TIPO_EFECTORES.CONTRATO_PRESTADORES ? (
                    "PRESTADOR"
                  ) : dataEfector?.idTipoEfector === TIPO_EFECTORES.INTEGRACION ? (
                    "INTEGRACIÓN"
                  ) : dataEfector?.idTipoEfector === TIPO_EFECTORES.PROVEEDOR ? (
                    "PROVEEDOR"
                  ) : null}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </React.Fragment>
  )
}

